import request from '@/utils/request'

// 查询图库列表
export function getMapList(query) {
  return request({
    url: '/server/map/list',
    method: 'get',
    params: query
  })
}

// 查询图库分类列表
export function getMapTypeList(query) {
  return request({
    url: '/server/map/type/list',
    method: 'get',
    params: query
  })
}

// 查询图库列表
export function getMapInfo(mapId) {
  return request({
    url: '/server/map/getInfo/' + mapId,
    method: 'get',
  })
}


// 查询图库列表
export function buyMap(data) {
  return request({
    url: '/server/map/buyMap',
    method: 'post',
    data: data
  })
}
